module.exports = __webpack_public_path__ + "img/ARMuseum.441f9735.png";